import { render, staticRenderFns } from "./present.vue?vue&type=template&id=572a02dc&scoped=true&"
import script from "./present.vue?vue&type=script&lang=js&"
export * from "./present.vue?vue&type=script&lang=js&"
import style0 from "./present.vue?vue&type=style&index=0&id=572a02dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572a02dc",
  null
  
)

export default component.exports